export default __webpack_public_path__ + "static/media/down-disabled.eec8332c.svg";